import 'babel-polyfill'
import 'amfe-flexible'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/assets/icon/iconfont.css'
import BackEvent from 'common/js/UBackEvent'
import { exitApp } from 'common/js/mobilePlugin'
// By default we import all the components.
// Only reserve the components on demand and remove the rest.
// Style is always required.
import {
  /* eslint-disable no-unused-vars */
  Loading,
  Popup,
  Toast,
  Picker,
  TimePicker,
  Dialog,
  ActionSheet,
  Scroll
} from 'cube-ui'
import App from './App'
import router from './router'
import Navigation from 'vue-navigation'
import * as filters from 'common/filter/filter'
// promise.ployfill()
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(Navigation, {router})
Vue.use(Loading)
Vue.use(Toast)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(ActionSheet)
Vue.use(Scroll)
Vue.use(Popup)

Vue.config.productionTip = false

/* eslint-disable no-new */

function onDeviceReady () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
  })
  // console.log(getUser())
  document.addEventListener('backbutton', onBackKeyDown, false)

  function onBackKeyDown () {
    if (BackEvent.isBindBackEvent(router.currentRoute)) {
      BackEvent.handBackEvent(router.currentRoute)
    } else {
      window.history.length > 1 ? router.back() : exitApp()
    }
  }
}

document.addEventListener('deviceready', onDeviceReady, false)



// WEBPACK FOOTER //
// ./src/main.js